






import { lazy } from "react";
import Loadable from "components/Loadable";

const VenueAdd = Loadable(lazy(() => import("pages/public/venue/VenueAdd")));
const ServiceAdd = Loadable(lazy(() => import("pages/public/services/ServiceAdd")));


const privateRoutes = [
  { path: "/venue/add", element: <VenueAdd /> },
  { path: "/service/add", element: <ServiceAdd /> },


  // { path: "/dashboard", element: <Analytics />, auth: authRoles.admin },

  // ...createCrudRoutes("/user", UserList, UserAddEdit, UserView, authRoles.admin, { list: true, add: true, edit: true, view: true }),
  // ...createCrudRoutes("/cms-page", CMSPageList, CMSPageAddEdit, CMSPageView, authRoles.admin, { list: true, add: true, edit: true, view: true }),
  // ...createCrudRoutes("/designation", DesignationList, DesignationAddEdit, DesignationView, authRoles.admin, { list: true, add: true, edit: true, view: true }),
  // ...createCrudRoutes("/status-category", StatusCategoryList, StatusCategoryAddEdit, StatusCategoryView, authRoles.admin, { list: true, add: true, edit: true, view: true }),
  // ...createCrudRoutes("/role", RoleList, RoleAddEdit, RoleView, authRoles.admin, { list: true, add: true, edit: true, view: true }),
  


  // Add more CRUD route sets as needed using createCrudRoutes with different options



];

export default privateRoutes;
